import React, { useContext, useEffect, useState } from "react";
import { useAppDispatch } from "../../store/store";
import { TranslationContextInterface } from "../../entities/Language";
import { TranslationContext } from "../../context/TranslationContext";
import { useSelector } from "react-redux";
import { getMixData } from "../../components/Mix/selectors";
import { fetchMixesByWebshop } from "../../components/Mix/actions";
import { getCurrentLanguageId } from "../../lang/utils";
import { getValueForKey } from "../../context/translationsUtils";
import MixWrapper from "../../components/Mix/MixWrapper/MixWrapper";
import Box from "../../UI/Box";
import Filter from "../../components/Filter/Filter";
import { SORTING_TYPE, VIEW_TYPE } from "../../entities/Filter";
import { MixInterface } from "../../entities/Mix";
import { sortByDirection } from "../../utils/sortByDirection";
import { clearSelectedCondiments } from "../../components/Condiment/CondimentSlice";
import { resetMixtureState } from "../../components/Mixture/MixtureSlice";
import { resetCalculationState } from "../../components/Calculation/slice/CalculationSlice";
import { getTenantCredentials } from "../../components/Tenant/selectors";
import { TenantCredentialsInterface } from "../../entities/Tenant";

const Mixes: React.FC = () => {
  const [sort, setSort] = useState<SORTING_TYPE>(SORTING_TYPE.ASC);
  const [view, setView] = useState<VIEW_TYPE>(VIEW_TYPE.GRID);
  const dispatch = useAppDispatch();
  const languageId = getCurrentLanguageId();
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const { id: operationalWebshopId } = useSelector(
    getTenantCredentials,
  ) as TenantCredentialsInterface;

  const { mixes = [] } = useSelector(getMixData);
  const [sortedMixes, setSortedMixes] = useState<MixInterface[]>([]);

  useEffect(() => {
    dispatch(fetchMixesByWebshop(operationalWebshopId));
  }, [languageId, dispatch]);

  useEffect(() => {
    if (mixes.length) {
      const sortedByDirectionMixes = sortByDirection([...mixes], sort);
      setSortedMixes(sortedByDirectionMixes);
    }
  }, [sort, mixes]);

  useEffect(() => {
    dispatch(clearSelectedCondiments());
    dispatch(resetCalculationState());
    dispatch(resetMixtureState());
  }, [dispatch]);

  return (
    <Box>
      <Filter sort={sort} setSort={setSort} view={view} setView={setView} />
      <MixWrapper
        title={getValueForKey(
          translations,
          "classic_inspiration.choose_a_mix_hint",
        )}
        view={view}
        mixes={sortedMixes}
      />
    </Box>
  );
};

export default Mixes;